import React, { useState } from "react";
import "../style/Certificate.css";
import webbanner from "../assets/banner/webbanner.jpg"
import LeaveMessage from "./LeaveMessage";

const Certificate = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      {/* ---------------- Search Results Placeholder ---------------- */}
      <div id="searchResults"></div>

   <LeaveMessage />

      {/* ---------------- Banner ---------------- */}
      <section>
        <img src={webbanner} alt="web-banner" />
      </section>

      {/* ---------------- Heading ---------------- */}
      <section>
        <div className="heading-section">
          <h2>CERTIFICATES AND HONOR</h2>
        </div>
      </section>

      {/* ---------------- Certificates ---------------- */}
      <section className="certificate-section">
        <div className="cert-img">
          <img src="/certificate/20221205115841_33844.jpg" alt="" />
          <img src="/certificate/20221205115854_61040.jpg" alt="" />
        </div>

        <div className="cert-p">
          <li>
            During 2007-2010, quality and safety is at the heart of A-OK's
            product philosophy. To enhance production efficiency and yield, ISO
            9001:2009 was introduced and hired the former director of Toyota
            Motor corporation of Japan and implemented Toyota's Lean Production
            System.
          </li>
          <li>
            To meet the ever-demanding needs of Government Regulation on product
            safety, A-OK had acquired safety-related certifications for
            electronic products across the global
          </li>
          <li>
            A-OK keep upgrading these certificates year by year, we got ISO
            9001:2015 TUV in 2019.
          </li>
          <li>
            During 2011-2012, Innovation is keeping A-OK ahead of the
            competition. A-OK has been granted "National High-tech Enterprise"
            in 2011. During this period, A-OK has established an R&D center in
            Stuttgart/Germany, cooperated with the core supplier of
            Mercedes-Benz, afterwards, A-OK obtained its 60 invention and
            utility model patents. Till 2021, with more than 180 patents
            acquired across global, A-OK is one of the most innovated companies
            in China's AI automation industry.
          </li>
        </div>

        <div className="cert-img">
          <img src="/certificate/20220221150002_84276.jpg" alt="" />
        </div>

        <div className="cert-p">
          <p>
            In 2021, A-OK attended R+T Stuttgart 2021 and got the bronze of its
            Innovation Award, such an honor inspired us to serve our global
            customers. As the only Chinese enterprise who won this honor since
            1998, we felt this is a landmark for Chinese companies, as we all
            know there is still a long way for us to gain a good manufacturing
            reputation as German, yet, this is really a good start for us.
          </p>
        </div>
      </section>
    </>
  );
};

export default Certificate;
